<template>
  <div class="row dsd-description" data-cy="dataset-description">

    <ol v-if="!getLoading && similarDatasets && similarDatasets.length > 0 && similarDatasets[0].hasOwnProperty('id')"
      class="nav nav-tabs nav-justified col-12 p-0 dataset-details-tabs"
      id="dataset-details-tabs"
      role="tablist"
      >
      <li class="nav-item" role="presentation">
        <button class="nav-link dataset-details-tab active" id="about-tab" data-toggle="tab" data-target="#about-dataset" type="button" role="tab" aria-controls="about-dataset" aria-selected="true">
          <span class="m-0" data-alt-text="Info"><span>Über diesen Datensatz</span></span>
        </button>
      </li>
      <li v-if="similarDatasets.length > 0" class="nav-item" role="presentation">
        <button class="nav-link dataset-details-tab" id="similar-tab" data-toggle="tab" data-target="#similar-datasets" type="button" role="tab" aria-controls="similar-datasets" aria-selected="false">
          <span class="m-0" data-alt-text="Ähnliche"><span>Ähnliche Datensätze</span></span>
        </button>
      </li>
    </ol>

    <div  class="dsd-description-content tab-content" id="dataset-details-tab-content">
      <div class="tab-pane fade show active" id="about-dataset" role="tabpanel" aria-labelledby="about-tab">
        <h5 class="by-heading-4 text-secondary">Über diesen Datensatz</h5>
        <div v-if="getDatasetDescription" property="dc:description">
          <app-markdown-content
            v-if="$env.content.datasetDetails.description.enableMarkdownInterpretation"
            class="by-copy-small-regular text-by-neutral-60"
            :text="truncate(getDatasetDescription, datasetDescriptionLength)">
          </app-markdown-content>
          <p v-else style="word-wrap:break-word;">
            <span class="mr-2">{{ truncate(getDatasetDescription, datasetDescriptionLength) | stripHtml }}</span>
          </p>
          <pv-show-more
            v-if="isDatasetDescriptionExpanded || (datasetDescriptionLength < getDatasetDescriptionLength)"
            :label="isDatasetDescriptionExpanded? 'Weniger lesen' : 'Mehr lesen'"
            :upArrow="isDatasetDescriptionExpanded"
            :action="toggleDatasetDescription"
            class="row text-primary dsd-description-show-more"
          />
        </div>
        <div v-else class="col-12 by-copy-small-regular text-muted font-italic">
          <p style="word-wrap:break-word;">
            {{ $t('message.catalogsAndDatasets.noDescriptionAvailable') }}
          </p>
        </div>
      </div>

      <div v-if="similarDatasets && similarDatasets.length > 0"
        class="tab-pane fade"
        id="similar-datasets"
        role="tabpanel"
        aria-labelledby="similar-tab"
        >
        <dataset-details-similar-datasets-carousel />
      </div>
    </div>

  </div>
  <div v-if="has23DegUrl" class="mt-1 dsd-distributions">
    <div class="distributions-header-container">
      <div class="distributions-header-title-container dsd-item d-flex flex-column align-items-start" style="position: relative;left: -15px;">
        <div class="distributions-header-title">
          <h2 class="distributions-header-title-title">Vorschau</h2>
        </div>
      </div>
      <hr>
      <div class="embed-container">
        <div class="">
          <div v-html="embed"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { AppMarkdownContent, getTranslationFor, truncate } from "@piveau/piveau-hub-ui-modules";
import { defineComponent, computed } from "vue";
// @ts-ignore
import { mapGetters, useStore } from "vuex";
import filtersMixin from '../../mixins/filters';
import DatasetDetailsSimilarDatasetsCarousel from './DatasetDetailsSimilarDatasetsCarousel.vue';
import { is23DegreesUrl, useEmbed23Deg } from "../../utils/embedBarchart";

export default defineComponent({
  name: "DatasetDetailsDescription",
  components: {
    AppMarkdownContent,
    DatasetDetailsSimilarDatasetsCarousel
  },
  mixins: [filtersMixin],
  data() {
    return {
      isDatasetDescriptionExpanded: false,
      datasetDescriptionLength: 500,
      INITIAL_DATASET_DESCRIPTION_LENGTH: 500,
      MAX_DATASET_DESCRIPTION_LENGTH: 100000
    }
  },
  computed: {
    ...mapGetters('datasetDetails', [
      'getLoading',
      'getDescription',
      'getLanguages',
      'getSimilarDatasets'
    ]),
    getDatasetDescription() {
      return getTranslationFor(this.getDescription, this.$route.query.locale, this.getLanguages);
    },
    getDatasetDescriptionLength() {
      return this.getDatasetDescription ? this.getDatasetDescription.length : 0;
    },
    similarDatasets() {
      return this.getSimilarDatasets;
    }
  },
  methods: {
    truncate,
    toggleDatasetDescription() {
      this.isDatasetDescriptionExpanded = !this.isDatasetDescriptionExpanded;
      if (this.datasetDescriptionLength === this.INITIAL_DATASET_DESCRIPTION_LENGTH) this.datasetDescriptionLength = this.MAX_DATASET_DESCRIPTION_LENGTH;
      else this.datasetDescriptionLength = this.INITIAL_DATASET_DESCRIPTION_LENGTH;
    }
  },
  setup() {
    const store = useStore();

    // getter datasetDetails/getIsReferencedBy as computed
    const getIsReferencedBy = computed(() => {
      return store.getters['datasetDetails/getIsReferencedBy'] || [];
    });

    // extracts first 23degrees url from isReferencedBy field
    const the23DegUrl = computed(() => {
      // Just find the first one, ignoring the rest, if there are multiple
      return getIsReferencedBy.value?.find(is23DegreesUrl) || '';
    })

    const has23DegUrl = computed(() => {
      return !!the23DegUrl.value;
    })

    const { embed } = useEmbed23Deg(the23DegUrl);

    return { getIsReferencedBy, has23DegUrl, embed }
  }
})
</script>

<style lang="scss" scoped>
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

@media screen and (max-width: 576px) {
  [data-alt-text] > span {
    display: none;
  }

  [data-alt-text]::before {
    content: attr(data-alt-text);
  }
}

.embed-container {
  max-width: 100%;
}

@include media-breakpoint-up(md) {
  .embed-container {
    max-width: 900px;
  }
}
</style>
